import { Search } from '@ori-ui/icons';
import type { TypographyProps, ChipProps } from '@ori-ui/mui';
import { Chip, Typography, chipClasses, styled } from '@ori-ui/mui';

import { CHIP_HEIGHT } from './constants';

export const Label = styled(Typography)<Pick<TypographyProps, 'component'>>({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  textTransform: 'none',
  verticalAlign: 'baseline',
});

export const StyledChip = styled(Chip)<Pick<ChipProps, 'component'>>(({ theme }) => ({
  height: CHIP_HEIGHT,
  padding: theme.spacing(1, 3),
  gap: theme.spacing(1),
  borderRadius: theme.spacing(2),
  [`.${chipClasses.icon}`]: {
    margin: 0,
  },
  [`.${chipClasses.label}`]: {
    padding: 0,
  },
}));

export const SearchIcon = styled(Search)({
  height: '24px',
  width: '24px',
});
